import {FC, ReactNode} from 'react'
import {Col, Row} from 'react-bootstrap'

interface PageSectionProps {
  children: ReactNode;
  title?: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

const PageSection: FC<PageSectionProps> = ({
  children,
  title,
  subtitle,
  actions,
  className = 'mb-4'
}) => {
  return (
    <Row className={className}>
      <Col xs={12}>
        {(title || subtitle || actions) && (
          <Row className="mb-3">
            <Col>
              {title && (
                <h5 className="visual-hierarchy-secondary mb-1">
                  {title}
                </h5>
              )}
              {subtitle && (
                <p className="text-secondary-contrast mb-0">
                  {subtitle}
                </p>
              )}
            </Col>
            {actions && (
              <Col xs="auto" className="d-flex align-items-center">
                {actions}
              </Col>
            )}
          </Row>
        )}
        {children}
      </Col>
    </Row>
  )
}

export default PageSection
